<template>
    <nav class="main-nav">
        <ul class="navbar_items">
            <li>
                <a href="/painel">Painel</a>
            </li>
            <li>
                <router-link :to="{ name: 'home' }">Censo</router-link>
            </li>
            <li class="dropdown">
                <a href="#" class="dropbtn">Relatórios</a>
                <div class="dropdown-content">
                   <router-link :to="{ name: 'ocupacaomeianoite' }">Taxa de Ocupação Meia Noite</router-link>
                   <router-link :to="{ name: 'pacientesinternados' }">Pacientes Admitidos</router-link>
                   <router-link :to="{ name: 'historicointernacoes' }">Histórico de Admissões</router-link>
                   <router-link :to="{ name: 'historicomovimentacao' }">Histórico de Movimentação de Leito</router-link>
                   <router-link :to="{ name: 'relatoriolongapermanencia' }">Pacientes acima de 24h</router-link>
                   <router-link :to="{ name: 'relatorioListagemInternacoes' }">Listagem de Admissões</router-link>
                </div>
            </li>
            <li>
                <a href="/publico/controller/encerrarSessao.php">Sair</a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
   
}
</script>

<style>
.navbar_items {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
}
.navbar_items li {
    margin-right: 0.4rem;
    padding: 0.62rem;
}

.navbar_items li:last-of-type {
    margin-right: 0;
}

.navbar_items li:hover {
    background-color: #ffffff;
}

.navbar_items li:hover a {
    color: rgb(46, 46, 46);
}

.main-nav a,
.main-nav a:active {
    color: #ffffff;
}


.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  margin-top: 9px;
  margin-left: -9px;
  background-color: #056f94;
  min-width: 160px;
  z-index: 1;
  text-align: left;
}

.dropdown-content-maior {
  min-width: 200px;
}

.dropdown-content a {
  color: white!important;
  padding: 10px 16px;
  text-decoration: none;
  display: block;
}

.dropdown:hover .dropbtn {
  color: #5d5b5b;
}

.dropdown-content a:hover {
  background-color: white !important;
  color: black !important;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover #relatorios {
  color: #5d5b5b;
}

.dropdown-item {
  color: black !important;
}
</style>
